module.exports = __webpack_public_path__ + "img/stock3.cfae0e9a.png";